import axios from "axios";
import { config, mediaMatch } from "../utils";
import qs from "qs";
import cookie from "../utils/cookies";
import store from "../reducer/store";
import { setDrawerLogin } from "../reducer/actions";
import cookies from "../utils/cookies";
import useNotice from "../hooks/useNotice";

const http = (req = { data: {} }, options) => {
  const notice = useNotice();
  const isMdmax = mediaMatch.isMdmax;
  let url = config.baseUrl + req.url;
  let agentId = cookie.get("MALLagentId");
  let aliasName = cookie.get("MALLaliasName");

  const headers = {
    method: "GET",
    mode: "cors",
    timeout: 20 * 1000,
    headers: {},
  };

  if (cookie.getToken() && !options?.noToken) {
    headers.headers["Authorization"] = "Bearer " + cookie.getToken();
  }

  if (!options?.noAlias) {
    if (req.data) req.data.aliasName = aliasName;
    if (req.aliasName) req.params.aliasName = aliasName;
  }

  if (!options?.noAgent) {
    if (req.data) req.data.agentId = agentId;
    if (req.params) req.params.agentId = agentId;
  }

  if (["post", "put", "delete"].includes(req.method)) {
    headers.method = req.method.toUpperCase(); //'POST';

    if (options?.json) {
      if (req.data) {
        headers.data = req.data;
        headers.data.t = new Date().getTime();
      }
      headers.headers["Content-Type"] = "application/json;charset=UTF-8";
    } else if (options?.formdata) {
      if (req.data) {
        let formatData = new FormData();
        for (let i in req.data) {
          formatData.append(i, req.data[i]);
        }
        headers.data = formatData;
      }
    } else {
      req.data
        ? (headers.data = qs.stringify({ ...req.data }))
        : (headers.params = req.params);
    }
  } else {
    headers.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";
    req.data.t = new Date().getTime();
    headers.params = req.data;
  }

  // headers.headers['Content-Type'] =
  //   'application/x-www-form-urlencoded;charset=UTF-8';
  headers.url = url;

  if (options && options.token && !cookies.getToken()) {
    if (!isMdmax) {
      store.dispatch(setDrawerLogin(true));
    } else {
      window.location.href =
        window.location.origin +
        window.location.pathname +
        "#/login?redirect=" +
        window.location.hash.replace("#", "");
    }
    return;
  }

  return new Promise((resolve, reject) => {
    axios
      .request(headers)
      .then((res) => {
        if (res.status === 200) {
          // 状态 200
          resolve({
            data: res.data.data || {},
            msg: res.data.message,
            code: res.data.code,
          });
        } else {
          resolve({
            data: false,
            err: res,
          });
        }
      })
      .catch((err) => {
        console.log(err, "err");
        let errData = err.response?.data || {};
        console.log(errData, "errData");

        if (errData.message) {
          notice.error(errData.message);
        }

        if (
          errData.code === 2000 ||
          errData.code === 2012 ||
          errData.message === "会话失效，请重新登录"
        ) {
          cookies.logout();
          setTimeout(() => {
            window.location.href =
              window.location.origin + window.location.pathname;
          }, 500);
        }

        resolve({
          data: errData.data,
          code: errData.code,
          error: errData.message,
        });
        // reject(err);
      });
  }); // 外层Promise 不能catch 否者axios无法reject
};

const reqDefaultConfig = {
  loadingDelay: 80,
};
export { reqDefaultConfig };
export default http;
